import React, { Component } from 'react'

export default class Seletor extends Component {
    render() {
        return (
            <div>
                seletor
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/SeletorCustomForm/components/Seletor.js